import { defineComponent, nextTick, ref, watch } from 'vue';
import styles from './index.module.less';
import clsx from 'clsx';
import FormSwitch from '../FormSwitch';
import Trafficlight from '../Trafficlight/index.vue';
import SpeedChart from '@/components/SpeedChart/index.vue';

const props = {
  statusInfos: {
    default: [],
  },
};

const Module2 = defineComponent({
  name: 'Module2',
  props,
  setup(props) {
    const hasAutoOpenCharts = () => {
      const autoOpen = JSON.parse(localStorage.getItem('autoOpenChart') ?? 'false');
      if (!autoOpen) return false;
      return Object.keys(localStorage).some((k) => {
        if (!k.startsWith('echart_')) return false;
        const cfg = JSON.parse(localStorage.getItem(k) || '{}');
        return !!cfg.isOpen;
      });
    };
    const activeTab = ref(
      (JSON.parse(localStorage.getItem('isOpenSpeedChart')) || hasAutoOpenCharts())?
      'chartList':'tool'
    );
    watch(
      () => activeTab.value,
      (activeTab) => {
        nextTick(() => {
          const tool = document.querySelector('#pane-tool');
          const chartList = document.querySelector('#pane-chartList');
          const trafficLight = document.querySelector(
            '#pane-tool .trafficLightPopover',
          );

          if (tool && chartList && trafficLight) {
            tool.removeAttribute('style');
            chartList.removeAttribute('style');

            if (activeTab === 'tool') {
              chartList.setAttribute('style', 'visibility:hidden;');
              let childNodes = chartList.childNodes;
              childNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.style.visibility = 'visible'; 
                }
              });
            } else {
              tool.setAttribute('style', 'visibility:hidden;height:0');
              trafficLight.style.visibility = 'visible';
            }
          }
        });
      },
    );
    return {
      props,
      activeTab,
    };
  },
  render() {
    return (
      <div
        class={clsx(styles.container, 'dark-bg')}
        style="padding: 10px;padding-top:0"
      >
        {/* <FormSwitch />
        <div style="width:100%; height: 130px; overflow:auto; position: relative;margin-top: 10px;">
          <Trafficlight />
        </div>
        <SpeedChart speedList={this.props.statusInfos} /> */}
        <el-tabs class={styles.tabs} v-model={this.activeTab}>
          <el-tab-pane label="工具栏" name="tool">
            <FormSwitch />
            <div>
              <Trafficlight />
            </div>
          </el-tab-pane>
          <el-tab-pane label="图表" lazy name="chartList" 
          >
            <div>
              <SpeedChart speedList={this.props.statusInfos} />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    );
  },
});

export default Module2;
